import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { ChartDoughnut, FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../../components/Global";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageThree from "./PageThree";
import LoadingPage from "./LoadingPage";
import { Chart, registerables } from "chart.js";
import { Col, Row } from "react-bootstrap";
Chart.register(...registerables);

const PageTwo = ({ idJadwalCbt, idKelas, idKelasParalel, kodeTahunAjaran, schoolName, isRiasec }) => {
    const [fetching, setFetching] = useState(false);
    const [dataDetailPsi, SetDataDetailPsi] = useState([]);
    const [detailLs, SetDetailLs] = useState([]);
    const [dataAq, SetDataAq] = useState([]);
    const [dataEq, SetDataEq] = useState([]);
    const [dataAm, SetDataAm] = useState([]);
    const [dataRiasec, SetDataRiasec] = useState([]);
    const [dataRiasecR, SetDataRiasecR] = useState([]);
    const [dataRiasecI, SetDataRiasecI] = useState([]);
    const [dataRiasecA, SetDataRiasecA] = useState([]);
    const [dataRiasecS, SetDataRiasecS] = useState([]);
    const [dataRiasecE, SetDataRiasecE] = useState([]);
    const [dataRiasecC, SetDataRiasecC] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);

            const params = {
                idJadwalCbt: idJadwalCbt,
                idKelas: idKelas,
                idKelasParalel: idKelasParalel,
                kodeTahunAjaran: kodeTahunAjaran,
            };

            const response = await accountManagement.get(CONFIG_DEV.REPORT_PEMETAAN3_PAGE_TWO, { params }).catch(function (error) {
                console.error("Error Response Page Two", error);
            });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Two ", responseAPI);
                    console.log("====================================");

                    SetDetailLs(responseAPI.detailLs);
                    SetDataDetailPsi(responseAPI.detailPsi);
                    SetDataAq(responseAPI.detailPsi[0]);
                    SetDataAm(responseAPI.detailPsi[1]);
                    SetDataEq(responseAPI.detailPsi[2]);
                }
                setFetching(false);
                setOpenPage(true);
            }

            if (isRiasec) {
                const responseRiasec = await accountManagement
                    .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_TWO_RIASEC, {
                        idJadwalCbt: idJadwalCbt,
                        idKelas: idKelas,
                        kodeTahunAjaran: kodeTahunAjaran,
                    })
                    .catch(function (error) {
                        console.error("Error Response Riasec Page Two", error);
                    });

                if (responseRiasec) {
                    if (responseRiasec.data.data) {
                        const responseAPIRiasec = responseRiasec.data.data;

                        SetDataRiasec(responseAPIRiasec);
                        console.log("====================================");
                        console.log("riasec", responseAPIRiasec[0].prosentase);
                        console.log("====================================");
                    }
                }

                // /pemetaan/reportsekolah_riasec
            } else {
                console.log("====================================");
                console.log("bukan riasec");
                console.log("====================================");
            }
        };
        getDatas();
    }, []);

    const options = {
        responsive: true,
        legend: {
            display: false,
            position: "bottom",
            labels: {
                fontSize: 14,
                fontColor: "#616469",
                fontFamily: "Calibri",
            },
        },
        plugins: {
            datalabels: {
                display: false,
                formatter: (value) => {
                    return value + "%";
                },
                color: "#fff",
                font: {
                    size: 9,
                    weight: "bold",
                },
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const labels = ["Adversity Qoutient", "Emotional Qoutient", "Achievement Motivation"];

    let data = {
        labels: labels,
        datasets: [
            {
                label: dataAq.keterangan,
                data: [dataAq.prosentaseBawah, dataEq.prosentaseBawah, dataAm.prosentaseBawah],
                backgroundColor: "#C4161C",
            },
            {
                label: dataEq.keterangan,
                data: [dataAq.prosentaseTengah, dataEq.prosentaseTengah, dataAm.prosentaseTengah],
                backgroundColor: "#FB8500",
            },
            {
                label: dataAm.keterangan,
                data: [dataAq.prosentaseAtas, dataEq.prosentaseAtas, dataAm.prosentaseAtas],
                backgroundColor: "#457B9D",
            },
            // {
            //     label: "test1",
            //     data: chartData,
            //     backgroundColor: chartColor,
            // },
        ],
    };

    require("../Pemetaan.css");
    return (
        <div>
            {/* {isRiasec && (
                <div className="report-page">
                    <div className="header-second-page">
                        <GridInline width={"100%"}>
                            <GridInline width={"80%"}>
                                <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                                <LabelTitle label={schoolName} size={18} bolder={700} color={"#fff"} />
                            </GridInline>

                            <GridInline width={"20%"}>
                                <div
                                    style={{
                                        border: "2px solid #fff",
                                        padding: 5,
                                        textAlign: "center",
                                        borderRadius: 10,
                                    }}
                                >
                                    <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                                </div>
                            </GridInline>
                        </GridInline>
                    </div>
                    <Gap height={20} />
                    <div className="section-three">
                        <div className="result">
                            <LabelTitle label={"Hasil Asesmen Learning Style"} size={18} bolder={700} color={"#212529"} />
                            <Gap height={20} />
                            <div className="rekap-table">
                                <GridInline width={"5%"} />
                                <GridInline width={"30%"} verticalAlign={"top"} paddingTop={50}>
                                    <ChartDoughnut
                                        valueChart={dataRiasec.map((item) => {
                                            return item.prosentase;
                                        })}
                                        chartColor={["#C4161C", "#1D3557", "#5C95FF", "#FFB703", "#944EBA", "#52B788"]}
                                        chartLabel={dataRiasec.map((item) => {
                                            return item.kodeAspekNonAkademik;
                                        })}
                                        // legend={false}
                                        datalabels={false}
                                    />
                                </GridInline>
                                <GridInline width={"5%"} />
                                <GridInline width={"60%"}>
                                    <LabelTitle label={"Keterangan :"} size={17} bolder={600} color={"#495057"} />
                                    <Gap height={10} />
                                    {dataRiasec.map((itemRiasec, i) => {
                                        return (
                                            <GridInline width={"30%"}>
                                                <LabelTitle label={itemRiasec.singkatan} size={16} bolder={600} color={"#495057"} />
                                                <LabelTitle label={itemRiasec.kodeAspekNonAkademik} size={16} bolder={400} color={"#616469"} />
                                                <Gap height={5} />
                                                <LabelTitle label={itemRiasec.prosentase + " % - " + itemRiasec.jumlahSiswa + " Siswa"} size={16} bolder={400} color={"#616469"} />
                                                <Gap height={20} />
                                            </GridInline>
                                        );
                                    })}
                                </GridInline>
                                <Gap height={30} />
                            </div>
                            <div className="head-table-result">
                                <GridInline width={"100%"} padding={15} marginLeft={15}>
                                    <GridInline width={"15%"} marginLeft={15} paddingTop={10}>
                                        <LabelTitle label={"Tema Project"} size={20} bolder={800} color={"#000"} />
                                    </GridInline>
                                    <GridInline>
                                        <LabelTitle label={"Deskripsi"} size={20} bolder={800} color={"#000"} />
                                    </GridInline>
                                </GridInline>
                            </div>
                            <div className="table-result">
                                {dataRiasec.map((itemRiasecTable, i) => {
                                    return (
                                        <div key={i}>
                                            <Row padding={15} marginLeft={15}>
                                                <Col sm={2} style={{ paddingLeft: 30, paddingTop: 27, paddingBottom: 27, borderRight: "1px solid #E9ECEF", borderBottom: "1px solid #E9ECEF" }}>
                                                    {itemRiasecTable.kodeAspekNonAkademik}
                                                </Col>
                                                <Col style={{ paddingTop: 27, paddingBottom: 27, borderBottom: "1px solid #E9ECEF" }}>{itemRiasecTable.keterangan}</Col>
                                            </Row>
                                        </div>
                                    );
                                })}
                            </div>
                            <Gap height={190} />
                        </div>
                    </div>
                </div>
            )} */}
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={700} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Hasil Asesmen Learning Style"} size={18} bolder={700} color={"#212529"} />
                        <Gap height={20} />
                        <div className="rekap-table">
                            <GridInline width={"40%"} verticalAlign={"top"} paddingTop={50}>
                                <ChartDoughnut
                                    valueChart={[detailLs.auditori, detailLs.visual, detailLs.kinestetik]}
                                    chartColor={["#FB8500", "#C4161C", "#1D3557"]}
                                    chartLabel={["Auditori", "Visual", "Kinestetik"]}
                                    // legend={false}
                                    datalabels={false}
                                />
                            </GridInline>
                            <GridInline width={"60%"}>
                                <LabelTitle label={"Keterangan :"} size={17} bolder={600} color={"#495057"} />
                                <Gap height={10} />
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Auditori"} size={16} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.auditori + " Siswa"} size={16} bolder={400} color={"#616469"} />
                                </GridInline>
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Visual"} size={16} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.visual + " Siswa"} size={16} bolder={400} color={"#616469"} />
                                </GridInline>
                                <GridInline width={"20%"}>
                                    <LabelTitle label={"Kinestetik"} size={16} bolder={400} color={"#616469"} />
                                    <Gap height={5} />
                                    <LabelTitle label={detailLs.kinestetik + " Siswa"} size={16} bolder={400} color={"#616469"} />
                                </GridInline>
                                <Gap height={16} />
                                <LabelTitle label={"Saran Pengelolaan Kelas :"} size={17} bolder={600} color={"#495057"} />
                                <Gap height={10} />
                                <LabelTitle label={"Visual"} size={16} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle
                                    label={
                                        "Ajarkan siswa siswi anda menggunakan mind map (peta konsep) dengan berbagai warna,karena siswa dengan kemampuan visual mudah mengingat dan memahami materi pada mind map dengan warna yang bervariasi. Jika memungkinkan, putarkan video pembelajaran"
                                    }
                                    size={16}
                                    bolder={400}
                                    color={"#616469"}
                                />
                                <Gap height={10} />
                                <LabelTitle label={"Auditori"} size={16} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle
                                    label={
                                        "Ajak siswa untuk aktif dalam diskusi. Biarkan siswa membaca materi pelajaran dengan keras karena mereka akan lebih cepat memahami materi jika membaca sambal mendengarkan apa yang dibaca. Jika siswa tidak mencatat di kelas, jangan terburu-buru memarahi, karena siswa dengan tipe auditory akan menangkap materi dengan cara mendengarkan."
                                    }
                                    size={16}
                                    bolder={400}
                                    color={"#616469"}
                                />
                                <Gap height={10} />
                                <LabelTitle label={"Kinestetik"} size={16} bolder={600} color={"#495057"} />
                                <Gap height={5} />
                                <LabelTitle label={"Ajaklah siswa untuk lebih banyak melakukan praktikum. Berikan ‘ice breaking’ setelah 20 atau 30 menit belajar."} size={16} bolder={400} color={"#616469"} />
                            </GridInline>
                            <Gap height={10} />
                            <Line color={"#E9ECEF"} />
                        </div>
                    </div>
                </div>
                {/* </div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div> */}
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Rata-Rata Hasil Psychology Potential"} size={18} bolder={700} color={"#212529"} />

                        <Gap height={20} />

                        <Bar data={data} options={options} />

                        <Gap height={20} />

                        <GridInline width={"100%"}>
                            <GridInline width={"33%"}>
                                <LabelTitle label={"Adversity Qoutient"} size={17} bolder={500} color={"#212529"} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#457B9D",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Atas " + dataAq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#FB8500",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata " + dataAq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#C4161C",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Bawah " + dataAq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"33%"}>
                                <LabelTitle label={"Emotional Qoutient"} size={17} bolder={500} color={"#212529"} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#457B9D",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Atas " + dataEq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#FB8500",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata " + dataEq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#C4161C",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Bawah " + dataEq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"33%"}>
                                <LabelTitle label={"Achievement Motivation"} size={17} bolder={500} color={"#212529"} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#457B9D",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Atas " + dataAm.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#FB8500",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata " + dataAm.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                                <Gap height={10} />
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "10%",
                                        backgroundColor: "#C4161C",
                                        height: 15,
                                        paddingBottom: 11,
                                    }}
                                >
                                    &nbsp;
                                </div>
                                <GridInline width={"90%"} paddingLeft={"5%"}>
                                    <LabelTitle label={"Rata-Rata Bawah " + dataAm.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                                </GridInline>
                            </GridInline>
                        </GridInline>
                    </div>
                </div>
            </div>
            {/* <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}

            {openPage ? <PageThree idJadwalCbt={idJadwalCbt} idKelas={idKelas} idKelasParalel={idKelasParalel} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageTwo;
